/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon24Regular = forwardRef('DataStructureGraphIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8h-2.548l2.963 4H18a4 4 0 0 1 0 8h-8a4 4 0 0 1 0-8h2.548l-2.963-4H6a4 4 0 0 1-4-4Zm4-2.5a2.5 2.5 0 0 0 0 5h8a2.5 2.5 0 0 0 0-5H6Zm4 12a2.5 2.5 0 0 0 0 5h8a2.5 2.5 0 0 0 0-5h-8Z" })));
});
